<template>
  <div id="container">
    <div class="todo">
      <h3 class="text1 animate__animated animate__fadeInUp animate__delay-1s">
        BIENVENIDOS a
      </h3>

      <svg class="no-seleccionable svg" viewBox="0 0 800 600">
        <symbol id="s-text">
          <text text-anchor="middle" x="50%" y="35%" class="text--line">
            VOXCOMP
          </text>
        </symbol>
        <g class="g-ants">
          <use xlink:href="#s-text" class="text-copy"></use>
          <use xlink:href="#s-text" class="text-copy"></use>
          <use xlink:href="#s-text" class="text-copy"></use>
          <use xlink:href="#s-text" class="text-copy"></use>
          <use xlink:href="#s-text" class="text-copy"></use>
        </g>
      </svg>
      <div class="g_body animate__animated animate__fadeInUp animate__delay-2s">
        <button @click="login()" class="g-button">
          <img
            class="g-logo"
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/157px-Google_%22G%22_Logo.svg.png"
            alt="Google Logo"
          />
          <p class="g-text">Sign in</p>
        </button>
        <button @click="login()" class="g-button">
          <p class="g-text">Invitado</p>
        </button>
      </div>

      <a
        class="botonInvitado animate__animated absolute text-black font-bold py-2 px-4 rounded"
        >Invitado</a
      >
    </div>
  </div>
</template>
<script>
import * as Three from "three";
import { TWEEN } from "three/examples/jsm/libs/tween.module.min";
// import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

// import { VertexNormalsHelper } from "three/examples/jsm/helpers/VertexNormalsHelper.js";
// import { VertexTangentsHelper } from "three/examples/jsm/helpers/VertexTangentsHelper.js";

export default {
  name: "FondoIntro",
  data() {
    return {
      url: "https://restserver-cg.onrender.com/api/auth/",

      cono: null,
      mostrarTexto1: true,
      mostrarTexto2: false,
      mostrarTexto3: false,
      camera: null,
      scene: null,
      renderer: null,
      mesh: null,
      gridHelper: null,
      rotar: false,
      tween1: null,
      tween2: null,
      transparente: null,
      modelo: null,
      loader: null,
      group: null,
      torusKnot: null,
      line: null,
    };
  },
  props: {
    comenzar: Boolean,
    siguiente: Number,
    anterior: Number,
  },
  methods: {
    async login() {
      // const googleUser = await this.$gAuth.signIn();
      // var profile = googleUser.getBasicProfile();
      // console.log("ID: " + profile.getId()); // Do not send to your backend! Use an ID token instead.
      // console.log("Name: " + profile.getName());
      // console.log("Image URL: " + profile.getImageUrl());
      // console.log("Email: " + profile.getEmail()); // This is null if the 'email' scope is not present.
      // var id_token = googleUser.getAuthResponse().id_token;

      // const data = { id_token };
      // console.log(data);
      // fetch(this.url + "google", {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify(data),
      // })
      //   .then((resp) => {
      //     console.log(resp);
      //     return resp.json();
      //   })
      //   .then(({ token }) => {
      //     console.log(token);
      //     localStorage.setItem("token", token);
      //     console.log(profile);
      //     if (localStorage.getItem("token") != "undefined") {
      //       console.log("logeado por formulario ya se genero el token");
      //       this.loggedIn = true;
      //       this.isLogin = this.$gAuth.isAuthorized;
      //       this.$router.push("/home");
      //     } else console.log("paila");
      //   })
      //   .catch(console.log);
      fetch(this.url + "login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          correo: "test1@gmail.com",
          password: "123456" /* profile.getEmail() */,
        }),
      })
        .then((resp) => {
          return resp.json();
        })
        .then(({ token }) => {
          console.log(token);
          localStorage.setItem("token", token);
          this.$router.push("/home");
        });
    },
    init: function () {
      let container = document.getElementById("container");
      this.camera = new Three.PerspectiveCamera(
        45,
        container.clientWidth / container.clientHeight,
        0.01,
        2000
      );
      this.camera.position.z = 16;
      this.scene = new Three.Scene();
      this.scene.rotation.x = Math.PI / 2;
      this.scene.rotation.y = -Math.PI;
      const spotLight = new Three.SpotLight(0xffffff, 0.7);
      spotLight.position.set(-10, 2, 10);

      const targetObject = new Three.Object3D();
      targetObject.position.set(-15, 5, 1);
      this.scene.add(targetObject);

      spotLight.target = targetObject;

      this.scene.add(spotLight.target);
      this.scene.add(spotLight);

      let geometry = new Three.BoxGeometry(1, 1, 1);
      let material = new Three.MeshNormalMaterial({
        // color: 0x0000ff,
        transparent: true,
        opacity: 1.0,
      });
      let material2 = new Three.MeshNormalMaterial({
        // color: 0x0000ff,
        transparent: true,
        opacity: 1.0,
      });
      // let material3 = new Three.MeshNormalMaterial({
      //   // color: 0x0000ff,
      //   transparent: true,
      //   opacity: 1.0,
      // });
      this.mesh = new Three.Mesh(geometry, material);
      this.mesh.position.y = 1.5;
      this.mesh.position.x = -14.3;
      this.mesh.position.z = 6.7;

      this.scene.add(this.mesh);

      const torusKnotGeo = new Three.TorusKnotGeometry(1, 0.3, 100, 16);
      // const material = new Three.MeshBasicMaterial({ color: 0xffff00 });
      this.torusKnot = new Three.Mesh(torusKnotGeo, material2);
      this.torusKnot.position.y = 4.5;
      this.torusKnot.position.x = -8.3;
      this.torusKnot.position.z = -5.7;
      this.scene.add(this.torusKnot);
      const light = new Three.PointLight();
      light.position.set(200, 100, 150);
      this.scene.add(light);

      this.scene.add(new Three.PointLightHelper(light, 15));
      this.loader = new GLTFLoader();
      this.loader.load("/models/LeePerrySmith.glb", (glb) => {
        this.modelo = glb.scene.children[0];
        console.log(this.modelo);

        // this.modelo.geometry.computeTangents(); // generates bad data due to degenerate UVs

        this.group = new Three.Group();
        this.group.scale.multiplyScalar(0.8);
        this.scene.add(this.group);

        // To make sure that the matrixWorld is up to date for the boxhelpers
        this.group.updateMatrixWorld(true);

        const materialWireframe = new Three.LineBasicMaterial({
          color: 0x0000ff,
          linewidth: 1,
          opacity: 0.45,
          linecap: "round", //ignored by WebGLRenderer
          linejoin: "round", //ignored by WebGLRenderer
        });
        // this.group.add(this.modelo);
        this.group.position.y = 1.5;
        this.group.position.x = 14.3;
        this.group.position.z = 2.7;
        const wireframe = new Three.WireframeGeometry(this.modelo.geometry);
        this.line = new Three.LineSegments(wireframe, materialWireframe);
        this.line.material.depthTest = true;
        // this.line.material.opacity = 0.45;
        this.line.material.transparent = true;
        // this.line.position.x = 4;
        this.group.add(this.line);
        // const boxHelper = new Three.BoxHelper(this.modelo);
        // this.group.add(boxHelper);
      }),
        (xhr) => {
          console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
        },
        (error) => {
          console.error(error);
        };

      const GeoCono = new Three.ConeGeometry(0.5, 1, 32);
      const geoCil = new Three.CylinderGeometry(0.5, 0.5, 1, 32);

      const cylinder2 = new Three.Mesh(geoCil, material);
      const cubo = new Three.Mesh(geometry, material);
      this.cono = new Three.Mesh(GeoCono, material);

      cubo.position.y = 4.5;
      cubo.position.x = 8.5;
      cubo.position.z = -5.7;

      cylinder2.position.y = 3;
      cylinder2.position.x = 9.3;
      cylinder2.position.z = -3.7;

      this.cono.position.y = 3.5;
      this.cono.position.x = 7.3;
      this.cono.position.z = -4;

      cubo.scale.set(1.5, 1.5, 1.5);
      this.cono.scale.set(1.5, 1.5, 1.5);
      cylinder2.scale.set(1.5, 1.5, 1.5);

      this.scene.add(cubo);
      this.scene.add(this.cono);
      this.scene.add(cylinder2);

      const size = 50;
      const divisions = 50;

      this.gridHelper = new Three.GridHelper(size, divisions);
      //   this.gridHel   per.rotation.x = Math.PI / 2;
      this.scene.add(this.gridHelper);

      const moverRotaciones1 = new TWEEN.Tween(this.cono.rotation)
        .to({ x: Math.PI / 2 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotaciones2.start();
        });
      const moverRotaciones2 = new TWEEN.Tween(this.cono.rotation)
        .to({ x: Math.PI }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotaciones1.start();
        });
      moverRotaciones2.start();

      const moverRotacionesCubo1 = new TWEEN.Tween(cubo.rotation)
        .to({ y: Math.PI / 2, x: -Math.PI }, 2000)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotacionesCubo2.start();
        });
      const moverRotacionesCubo2 = new TWEEN.Tween(cubo.rotation)
        .to({ y: Math.PI, x: Math.PI / 2 }, 2000)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotacionesCubo1.start();
        });
      moverRotacionesCubo1.start();

      const moverRotacionesCyli1 = new TWEEN.Tween(cylinder2.rotation)
        .to({ x: Math.PI / 2, z: -Math.PI }, 2250)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotacionesCyli2.start();
        });
      const moverRotacionesCyli2 = new TWEEN.Tween(cylinder2.rotation)
        .to({ x: Math.PI, z: Math.PI / 2 }, 2250)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverRotacionesCyli1.start();
        });
      moverRotacionesCyli1.start();

      this.tween1 = new TWEEN.Tween(this.scene.rotation)
        .to({ x: 0.2, y: 0 }, 6000)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {});

      this.tween2 = new TWEEN.Tween(this.scene.position)
        .to({ z: -12 }, 6000) //6000
        .easing(TWEEN.Easing.Cubic.InOut);

      const moverTorus1 = new TWEEN.Tween(this.torusKnot.scale)
        .to({ x: 1.5, y: 1.5, z: 1.5 }, 3500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus2.start();
        });
      const moverTorus2 = new TWEEN.Tween(this.torusKnot.scale)
        .to({ x: 1, y: 1, z: 1 }, 3500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus3.start();
        });
      const moverTorus3 = new TWEEN.Tween(this.torusKnot.position)
        .to({ y: 7.5 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus4.start();
        });
      const moverTorus4 = new TWEEN.Tween(this.torusKnot.position)
        .to({ y: 3.5 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus5.start();
        });
      const moverTorus5 = new TWEEN.Tween(this.torusKnot.rotation)
        .to({ x: Math.PI / 2, y: Math.PI / 2, z: Math.PI / 2 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus6.start();
        });
      const moverTorus6 = new TWEEN.Tween(this.torusKnot.rotation)
        .to({ x: Math.PI, y: Math.PI, z: Math.PI }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverTorus1.start();
        });
      moverTorus1.start();

      const moverCubo1 = new TWEEN.Tween(this.mesh.position)
        .to({ x: -14.3 + 2 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverCubo2.start();
        });
      const moverCubo2 = new TWEEN.Tween(this.mesh.position)
        .to({ x: -14.3 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverCubo3.start();
        });
      const moverCubo3 = new TWEEN.Tween(this.mesh.position)
        .to({ y: 3.5 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverCubo4.start();
        });
      const moverCubo4 = new TWEEN.Tween(this.mesh.position)
        .to({ y: 1.5 }, 2500)
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          moverCubo1.start();
        });
      moverCubo1.start();
      this.transparente = new Three.MeshLambertMaterial({
        color: 0x0000ff,
        transparent: true,
        opacity: 0.0,
      });

      let maxX = 2;
      let axisXLength = maxX * 2;
      const axisXHeadLength = axisXLength * 0.25;
      const axisXHeadWidth = axisXHeadLength * 1;
      const directionX = new Three.Vector3(1, 0, 0);
      const startX = new Three.Vector3(-maxX, 0, 0);
      const colorX = 0xff0000;
      const axisX = new Three.ArrowHelper(
        directionX,
        startX,
        axisXLength + axisXHeadLength * 2,
        colorX,
        axisXHeadLength,
        axisXHeadWidth
      );
      axisX.position.x = -15;
      axisX.position.y = 1;
      axisX.position.z = 6;

      const geometryX = new Three.CylinderGeometry(0.15, 0.15, 5, 32);
      const materialX = new Three.MeshPhongMaterial({ color: colorX });
      const cylinder = new Three.Mesh(geometryX, materialX);
      cylinder.rotation.z = Math.PI / 2;
      cylinder.position.x = -12.5;
      cylinder.position.y = 1;
      cylinder.position.z = 6;
      this.scene.add(cylinder);

      this.scene.add(axisX);

      let axisYLength = maxX * 2;
      const axisYHeadLength = axisYLength * 0.25;
      const axisYHeadWidth = axisYHeadLength;
      const directionY = new Three.Vector3(0, 1, 0);
      const startY = new Three.Vector3(0, maxX, 0);
      const colorY = 0x00ff00;
      const axisY = new Three.ArrowHelper(
        directionY,
        startY,
        axisYLength + axisYHeadLength * 2,
        colorY,
        axisYHeadLength,
        axisYHeadWidth
      );
      axisY.position.x = -15;
      axisY.position.y = 1;
      axisY.position.z = 6;

      const materialY = new Three.MeshPhongMaterial({ color: colorY });
      const cylinderY = new Three.Mesh(geometryX, materialY);
      cylinderY.rotation.y = Math.PI / 2;
      cylinderY.position.x = -15;
      cylinderY.position.y = 3.5;
      cylinderY.position.z = 6;
      this.scene.add(cylinderY);
      this.scene.add(axisY);

      let axisZLength = maxX * 2;
      const axisZHeadLength = axisZLength * 0.25;
      const axisZHeadWidth = axisZHeadLength;
      const directionZ = new Three.Vector3(0, 0, 1);
      const startZ = new Three.Vector3(0, 0, maxX);
      const colorZ = 0x0000ff;
      const axisZ = new Three.ArrowHelper(
        directionZ,
        startZ,
        axisZLength + axisZHeadLength * 2,
        colorZ,
        axisZHeadLength,
        axisZHeadWidth
      );
      axisZ.position.x = -15;
      axisZ.position.y = 1;
      axisZ.position.z = 6;

      const materialZ = new Three.MeshPhongMaterial({ color: colorZ });
      const cylinderZ = new Three.Mesh(geometryX, materialZ);
      cylinderZ.rotation.x = Math.PI / 2;
      cylinderZ.position.x = -15;
      cylinderZ.position.y = 1;
      cylinderZ.position.z = 3.5 + 5;
      this.scene.add(cylinderZ);

      this.scene.add(axisZ);

      this.renderer = new Three.WebGLRenderer({ antialias: true });
      this.renderer.setSize(container.clientWidth, container.clientHeight);
      container.appendChild(this.renderer.domElement);
    },
    onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();

      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },
    animate: function () {
      if (this.$router.history.current.path == "/") {
        window.addEventListener("resize", this.onWindowResize);
        if (this.modelo) {
          this.group.rotation.y += 0.009;
        }
        requestAnimationFrame(this.animate);
        TWEEN.update();
        this.renderer.render(this.scene, this.camera);
      }
    },
  },
  mounted() {
    if (
      localStorage.getItem("token") &&
      localStorage.getItem("token") != "undefined"
    ) {
      console.log("ya esta logueado");
      this.$router.push("/home");
    }
    this.init();
    this.animate();
  },
};
</script>
<style scoped src="@/styles/intro.css"></style>
